const findCookie = (name: string): string | undefined =>
  document.cookie.split(";").find((c) => c.trim().startsWith(`${name}=`));

/**
 * Read a cookie value by name from `document.cookie`.
 *
 * @param name - The cookie name.
 * @returns The decoded value, or `undefined` if the cookie is absent.
 */
export const getCookie = (name: string): string | undefined => {
  const match = findCookie(name);
  if (!match) return undefined;
  const raw = match.split("=").slice(1).join("=").trim();
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
};
